import { WSQueryConfig } from "@ws-react-query";

import { useWSQuery } from "../../helpers";
import { QUERY_IDENTITY_VERIFICATION_REQUEST } from "../keys";
import { getIdentityVerificationRequest } from "../../../services/identityVerification/getIdentityVerificationRequest";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";

export const useQueryIdentityVerificationRequest = (
  id: string,
  queryConfig?: WSQueryConfig<IIdentityVerificationRequestResponse, unknown>
) =>
  useWSQuery(
    [QUERY_IDENTITY_VERIFICATION_REQUEST, id],
    () => getIdentityVerificationRequest(id),
    {
      retry: false,
      refetchOnMount: false,
      ...queryConfig
    }
  );
